module.exports = __webpack_public_path__ + "static/media/logo.f437daf0.png";